



















































import Vue from 'vue';
// import * as $ from 'jquery';
import _ from 'lodash';
import PropertyResultsMapList from './property-results-map-list.vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { getModule } from "vuex-module-decorators";
import UserAuth from "@/store/auth/UserAuth";

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAP_API_KEY,
  },
  // Demonstrating how we can customize the name of the components
  installComponents: true,
  v: '3.39',
});

export default Vue.extend({

  name: 'PropertyResultsMap',

  components: {
    'property-results-map-list': PropertyResultsMapList,
    'google-map': VueGoogleMaps.Map,
    'google-marker': VueGoogleMaps.Marker,
  },

  props: {
    choicesProp: {
      type: Array,
      default: [] as any,
    },
  },

  data() {
    return {
      choices: [] as any,
      mapTypeId: "roadmap",
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        gestureHandling: 'cooperative',
        v: '3.39',
      },
      center: {
        lat: 51.05,
        lng: -114.09,
      },
      zoom: 12,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -40
        }
      },
    };
  },

  created() {
  },

  mounted() {

  },

  updated() {
  },

  watch: {

    choicesProp(newVal, oldVal) {
      this.choices = newVal;
      var gmap: any = this.$refs.vueGoogleMap;
      //set bounds of the map
      gmap.$mapPromise.then((gm: any) => {
        //@ts-ignore
        const bounds: any = new google.maps.LatLngBounds();
        if (newVal.length) {
          for (let val of newVal) {
            bounds.extend(val.position);
          }
          gm.setCenter(bounds.getCenter());
          gm.fitBounds(bounds);
        } else {
          bounds.extend(this.center);
          gm.setZoom(12);
        }
        console.log(gm);
      });
    },

  },

  computed: {
    idToken(): any {
      return getModule(UserAuth).user;
    }
  },

  methods: {
    rolloverCreate(choice: any): string {
      const photoUrl: string = this.getPropertyValue(choice, "Photo URL");
      const image: string = (photoUrl ? photoUrl : 'https://www.godeepak.com/wp-content/plugins/post-type-x/core/img/no-default-thumbnail.png');
      const imgContent: string = '<div style="background-image: url(\'' + image + '\');" class="rollover-image"></div>';
      const price: string = '<span class="rollover-price">$'
          + Number(this.getPropertyValue(choice, "Price")).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          + '</span>';
      const address: string = '<span class="rollover-address">' + this.getPropertyValue(choice, "Street Address") + '</span>';
      const beds: string = '<span class="rollover-beds">Beds: ' + this.getPropertyValue(choice, "Bedrooms") + '</span>';
      const baths: string = '<span class="rollover-baths">Baths: ' + this.getPropertyValue(choice, "Bathrooms") + '</span>';
      const mls: string = '<span class="rollover-mls">MLS® #: ' + choice.name + '</span>';
      const broker: string = '<span class="rollover-broker">' + this.getPropertyValue(choice, "Broker Name") + '</span>';
      const response: string = '<div class="gmap-rollover">' + imgContent
          + '<div class="rollover-text">' + price + '<br />' + address + '<br />' + beds
          + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
          + baths + '<br />' + mls + '<br />' + broker
          + '</div></div>';
      return response;
    },
    panMap(position: any) {
      // For smooth panning of map within current bounds
      // If marker is outside of map bounds, then must use gMap center() method
      var map: any = this.$refs.vueGoogleMap;
      map.$mapPromise.then((gm: any) => {
        // const adjustedPosition: any = {};
        // adjustedPosition.lat = position.lat * ( 1 + ( 0.25 * ( 1 / (this.zoom * 500) ) ) );
        // adjustedPosition.lng = position.lng;
        gm.panTo(position);
      });
    },
    updateMapType(type: string) {
      // for changing Map Type [roadmap, terrain]
      this.mapTypeId = type;
    },
    closeInfoWindow() {
      this.infoWinOpen = false;
    },
    toggleInfoWindow(choice: any, idx: any) {
      this.infoWindowPos = choice.position;
      const rolloverContent: string = this.rolloverCreate(choice);
      this.infoOptions.content = rolloverContent;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getPropertyValue(choice: any, name: string) {
      return choice[_.camelCase(name)]
    },

  },

});

